// extracted by mini-css-extract-plugin
module.exports = {"modalWarp":"src-basic-component-ModifyPassModal-index-module__modalWarp--1nIXc"};